(function () {
  if (window.deinFriseurPromoFourForThree) return;
  window.deinFriseurPromoFourForThree = true;

  const TITLE_WORDS = ['Goldwell', 'Dualsenses', 'Stylesign'];
  const TITLE_PATTERN = new RegExp(`\\b(?:${TITLE_WORDS.join('|')})\\b`, 'gi');

  function markCampaignPage() {
    document.documentElement.classList.toggle('promo-4-for-3-active', Boolean(document.querySelector('[data-promo-campaign-page]')));
  }

  function cleanTitleText(value) {
    return value
      .replace(TITLE_PATTERN, '')
      .replace(/\s+/g, ' ')
      .replace(/^[\s\-–—,.:;·•&]+|[\s\-–—,.:;·•&]+$/g, '')
      .trim();
  }

  function cleanCampaignCardTitles() {
    document.querySelectorAll('[data-promo-actions][data-context="card"]').forEach((actions) => {
      const card = actions.closest('product-card, .product-card, .product-grid__card, .grid__item');
      if (!card || card.dataset.promoTitleCleaned === 'true') return;

      card
        .querySelectorAll('.text-block--product_title, .card__heading, .product-title, a[href*="/products/"]')
        .forEach((title) => {
          if (title.closest('[data-promo-actions]')) return;
          const walker = document.createTreeWalker(title, NodeFilter.SHOW_TEXT);
          let textNode;
          while ((textNode = walker.nextNode())) {
            TITLE_PATTERN.lastIndex = 0;
            if (TITLE_PATTERN.test(textNode.nodeValue || '')) textNode.nodeValue = cleanTitleText(textNode.nodeValue || '');
          }
        });

      card.dataset.promoTitleCleaned = 'true';
    });
  }

  async function copyDiscountCode(button) {
    const code = button.dataset.discountCode || '';
    const container = button.closest('.promo-4-for-3-code');
    const status = container?.querySelector('[data-copy-status]');
    if (!code) return;

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        const helper = document.createElement('textarea');
        helper.value = code;
        helper.setAttribute('readonly', '');
        helper.style.position = 'fixed';
        helper.style.opacity = '0';
        document.body.appendChild(helper);
        helper.select();
        document.execCommand('copy');
        helper.remove();
      }
      if (status) status.textContent = 'Code kopiert.';
      button.textContent = 'Kopiert';
      window.setTimeout(() => {
        button.textContent = 'Code kopieren';
      }, 1800);
    } catch (error) {
      if (status) status.textContent = `Bitte manuell kopieren: ${code}`;
    }
  }

  function updateVariant(event) {
    const variant = event.detail?.resource;
    if (!variant?.id) return;

    const productId = String(event.detail?.data?.productId || event.target?.dataset?.productId || '');
    const scope = event.target?.closest?.('.shopify-section, dialog, product-card') || document;
    scope.querySelectorAll('[data-promo-actions]').forEach((actions) => {
      if (productId && actions.dataset.productId !== productId) return;
      actions.querySelectorAll('[data-promo-variant-input]').forEach((input) => {
        input.value = variant.id;
      });
      actions.querySelectorAll('button[type="submit"]').forEach((button) => {
        const available = variant.available !== false;
        button.disabled = !available;
        const label = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
        if (label) button.textContent = label;
      });
    });
  }

  function updateQuantity(button) {
    const wrapper = button.closest('.promo-4-for-3-quantity');
    const input = wrapper?.querySelector('input[name="quantity"]');
    if (!input) return;
    const delta = Number.parseInt(button.dataset.promoQuantityChange || '0', 10);
    const minimum = Number.parseInt(input.min || '1', 10);
    const current = Number.parseInt(input.value || String(minimum), 10);
    input.value = String(Math.max(minimum, current + delta));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function refreshCampaignUi() {
    markCampaignPage();
    cleanCampaignCardTitles();
  }

  document.addEventListener('click', (event) => {
    const copyButton = event.target.closest('[data-copy-discount]');
    if (copyButton) {
      event.preventDefault();
      copyDiscountCode(copyButton);
      return;
    }

    const quantityButton = event.target.closest('[data-promo-quantity-change]');
    if (quantityButton) {
      event.preventDefault();
      updateQuantity(quantityButton);
    }
  });

  document.addEventListener('variant:update', updateVariant);

  let refreshQueued = false;
  const observer = new MutationObserver(() => {
    if (refreshQueued) return;
    refreshQueued = true;
    window.requestAnimationFrame(() => {
      refreshQueued = false;
      refreshCampaignUi();
    });
  });

  function init() {
    refreshCampaignUi();
    const target = document.getElementById('MainContent') || document.body;
    if (target) observer.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
